import URI from 'urijs';
import { useLLMSetting } from '../Components/Contexts';
import { LLMModel } from '../Components/Contexts/LLMSettingContext';

export function useIsVivara() {
  const { model } = useLLMSetting();
  const uri = new URI(window.location.href);
  const query = uri.query(true);

  return model === LLMModel.Companion && query.isVivara === 'true';
}
